const fontFamilies = {
	ui: "'SUIT Variable', sans-serif",
	display: '"source-han-serif-korean", serif',
};

const headingSizes = {
	h1: {
		fontWeight: 900,
		fontSize: "2.6rem",
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
		wordSpacing: "0.02em",
	},
	h2: {
		fontWeight: 800,
		fontSize: "2.1rem",
		lineHeight: 1.22,
		letterSpacing: "-0.015em",
		wordSpacing: "0.015em",
	},
	h3: {
		fontWeight: 800,
		fontSize: "1.6rem",
		lineHeight: 1.26,
		letterSpacing: "-0.01em",
		wordSpacing: "0.01em",
	},
	h4: {
		fontWeight: 800,
		fontSize: "1.35rem",
		lineHeight: 1.32,
		letterSpacing: "-0.006em",
		wordSpacing: "0.01em",
	},
	h5: {
		fontWeight: 800,
		fontSize: "1.15rem",
		lineHeight: 1.4,
		letterSpacing: "-0.003em",
		wordSpacing: "0.008em",
	},
	h6: {
		fontWeight: 800,
		fontSize: "0.95rem",
		lineHeight: 1.45,
		letterSpacing: "0em",
		wordSpacing: "0.006em",
	},
};

const displaySizes = {
	d1: { ...headingSizes.h1 },
	d2: { ...headingSizes.h2 },
	d3: { ...headingSizes.h3 },
	d4: { ...headingSizes.h4 },
	d5: { ...headingSizes.h5 },
	d6: { ...headingSizes.h6 },
};

export default {
	fontFamilies,
	// 12,14,16,20
	fontSizes: {
		xs: "0.6rem",
		sm: "0.75rem",
		md: "0.9rem",
		lg: "1.05rem",
		xl: "1.2rem",
	},
	headings: {
		fontFamily: fontFamilies.ui,
		sizes: headingSizes,
	},
	display: {
		fontFamily: fontFamilies.display,
		sizes: displaySizes,
	},
};
